import { createSlice } from "@reduxjs/toolkit";

const initialScrimState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  gameForEdit: [],
  gameForEdit1: [],
  lastError: null,
  country: [],
  currency: [],
  singleCompanyFetched:[],
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const GameScrimSetting = createSlice({
  name: "gamescrimSetting",
  initialState: initialScrimState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    country: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.country = entities;
      // state.totalCount = totalCount;
  },
  currency: (state, action) => {
    const { totalCount, entities } = action.payload;
    // console.log(entities)
    state.listLoading = false;
    state.error = null;
    state.currency = entities;
    // state.totalCount = totalCount;
},
    
    singleItemFetchedd: (state, action) => {
      console.log(action.payload, 'action.payload')
      state.actionsLoading = false;
      state.gameForEdit1 = action.payload.gameForEdit1;
      state.error = null;
    },

    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.gameForEdit = action.payload.gameForEdit;
      state.error = null;
    },
    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    singleCompanyFetched: (state, action) => {
      state.actionsLoading = false;
      state.singleCompanyFetched = action.payload.singleCompanyFetched;
      state.error = null;
  },
  }
});
